import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { ActionLink } from 'components/shared';
import useVideoDownloadInfo from './useVideoDownloadInfo';

const SingleVideoDownloadModal = ({ videoNodeId, isOpen, onRequestClose }) => {
  const [ready, sizeString, downloadUrl] = useVideoDownloadInfo({
    videoNodeId,
  });

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel="Video download modal"
      overlayClassName="modal"
      className="modal-content-wrap"
    >
      <ActionLink className="modal-close-button" onClick={onRequestClose}>
        <i className="mdi mdi-close" />
      </ActionLink>
      <h3 className="modal-title">
        <FormattedMessage
          id="Videos.singleVideoDownloadModal.downloadVideo"
          defaultMessage="Download Video"
          description="section header"
        />
      </h3>
      <span className="instructions">
        <FormattedMessage
          id="Videos.singleDownloadModal.modified"
          defaultMessage="You may need to right click and choose 'Save link as...'"
          description="message to the user"
        />
      </span>
      {ready ? (
        <div className="btn-container full">
          <a href={downloadUrl}>{`Download video (${sizeString})`}</a>
        </div>
      ) : (
        <span>The video download may not be available yet.</span>
      )}
    </Modal>
  );
};

SingleVideoDownloadModal.propTypes = {
  videoNodeId: PropTypes.string,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default SingleVideoDownloadModal;
